import { all, put, call, takeEvery } from 'redux-saga/effects';
import { LOAD_DASHBOARD_CARDS } from './types';
import { dashboardCardAction } from './actions';
import { errorAlert } from '../../Common/alerts';
import { getZwalletUserAccountGraphQL } from './graphql';

function* dashboardCards(data) {
  const { payload } = data;

  try {
      const { balance, incomes, outcomes, operationsCount, futureReleases } = yield call(getZwalletUserAccountGraphQL, payload);
      yield put(dashboardCardAction({ balance, incomes, outcomes, operationsCount, futureReleases }));
  } catch(error) {
      errorAlert("Ops...", error);
  }
}

function* watchDashboardCards() {
  yield takeEvery(LOAD_DASHBOARD_CARDS, dashboardCards);
}

export default function* rootSaga() {
  yield all([watchDashboardCards()]);
}


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/sagas.js